<p-toast></p-toast>

<div class="landing-page">

  <!-- LEFT PANEL -->
  <div class="landing-panel left-panel">
    <div class="panel-content">

      <h1 class="headline">Lipsum text for this page</h1>

      <div class="visual-grid">
        <img src="../../../../assets/images/gradpilot.png"
             alt="GradPilots + LinkedIn"
             style="width: 100%; max-width: 420px;">
      </div>

      <div class="import-section">
        <div class="import-label">WHAT WE'LL IMPORT</div>
        <div class="import-table">
          <div class="import-row">
            <span class="import-item">Full Name</span>
            <span class="import-item">Location</span>
            <span class="import-item">Education</span>
          </div>
          <div class="import-row">
            <span class="import-item">Languages</span>
            <span class="import-item">Skills</span>
            <span class="import-item">Experience</span>
          </div>
        </div>
      </div>

      <div class="footer-note">
        <span class="footer-item"><i class="pi pi-lock"></i> Read-only access</span>
        <span class="footer-dot">•</span>
        <span class="footer-item"><i class="pi pi-shield"></i> We never post on your behalf</span>
        <span class="footer-dot">•</span>
        <span class="footer-item"><i class="pi pi-check"></i> GDPR compliant</span>
      </div>

    </div>
  </div>

  <!-- RIGHT PANEL -->
  <div class="landing-panel">
    <div class="auth-card">

      <img src="../../../../assets/images/gradpilotslogo.png"
           alt="GradPilots"
           class="brand-logo">

      <h2 class="headline-right">
        You don't have to start
        <span class="no-break">from <span class="highlight">scratch</span></span>
      </h2>

      <p class="subtitle-right">
        Paste your LinkedIn profile link we'll pull in your details
        automatically. No login or sign-up needed.
      </p>

      <div class="linkedin-card">
        <div class="linkedin-card-header">
          <div class="linkedin-label-row">
            <span class="li-icon"><i class="pi pi-linkedin"></i></span>
            <span class="linkedin-label">LinkedIn Profile URL</span>
          </div>
          <span class="public-only">Public profile only</span>
        </div>

        <input id="linkedinUrl"
               type="text"
               [(ngModel)]="linkedinUrl"
               pInputText
               class="form-control"
               placeholder="Enter your LinkedIn Profile link"
               (keyup.enter)="fetchFromLinkedIn()" />
        <small class="input-hint">e.g. linkedin.com/in/arjun-sharma</small>

        <button class="fetch-button"
                (click)="fetchFromLinkedIn()"
                [disabled]="!linkedinUrl.trim()">
          Fetch My Information &nbsp;&rarr;
        </button>
      </div>

      <div class="divider"><span>OR</span></div>

      <button class="skip-button" (click)="selectManual()">
        Skip I'll fill it in myself &nbsp;&rsaquo;
      </button>

    </div>
  </div>

</div>

<!-- MODAL — outside layout div so overlay covers full viewport -->
<app-linkdindetails-fetch
  *ngIf="isModalVisible"
  [isVisible]="isModalVisible"
  (onComplete)="onLinkedInDataExtracted($event)"
  (onClose)="onModalClose()">
</app-linkdindetails-fetch>